import React from "react";
import Banner from "../../components/Banner/Banner";

import Sales from "../../components/Sales/Sales";

import WhoWeAre from "../../components/WhoWeAre/WhoWeAre";

import LayoutOne from "../../layouts/LayoutOne";

const Home = () => {
  return (
    <LayoutOne>
      <main className="fix">
        <Banner />
        <WhoWeAre />

        
        
        <Sales />

       

        
      </main>
      </LayoutOne>
  );
};

export default Home;